import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { WindowOpen } from '@zenlayer/portal-utils';
import { Button, Icon, Spin, Typography, notification, } from '@zenlayer/zen-design';
import t from '@zenlayer/zen-intl18';
import { useCountDown, useRequest } from 'ahooks';
import copy from 'copy-to-clipboard';
import { useState } from 'react';
import { createRoot } from 'react-dom/client';
import { JsonView, allExpanded, defaultStyles } from 'react-json-view-lite';
import 'react-json-view-lite/dist/index.css';
import { getAuditlogList, } from '../../api/auditlog';
import { detailUrlParamsParse, useDetailDrawer } from '../detail-drawer';
import cls from './index.module.less';
const Detail = () => {
    const { docId, isDefaultPartner, ...params } = detailUrlParamsParse(window.location.search);
    const [value, setValue] = useState();
    const Request = useRequest(() => {
        return getAuditlogList({ docId, ...params });
    }, {
        onSuccess: (res) => {
            if (res.success) {
                // eslint-disable-next-line @typescript-eslint/no-unused-vars
                const { docId, sortValues, ...showJSON } = res.data?.[0] || {};
                setValue(showJSON);
            }
            else {
                notification.error({ description: res.msg });
            }
        },
    });
    //Copy
    const [copyOk, setCopyOk] = useState(false);
    const [targetDate, setTargetDate] = useState();
    useCountDown({
        targetDate,
        onEnd: () => {
            setCopyOk(false);
        },
    });
    return (_jsxs(Spin, { spinning: Request.loading, children: [_jsxs(Typography.Title, { className: "mb-3", extra: _jsx(Button, { type: "text", size: "s", icon: copyOk ? (_jsx(Icon, { type: "suggest/Check" })) : (_jsx(Icon, { type: "general/Copy" })), onClick: () => {
                        copy(JSON.stringify(value, undefined, 4) || '{}');
                        setCopyOk(true);
                        setTargetDate(Date.now() + 3000);
                    }, children: t('SBBAwUKYUAGI') }), children: [_jsx("span", { children: t('5iNwpNlSFecL') }), isDefaultPartner === 'true' && (_jsx(Button, { type: "text", size: "s", icon: _jsx(Icon, { type: "general/File" }), onClick: () => {
                            new WindowOpen('https://docs.console.zenlayer.com/welcome/platform/audit-logs#field-explanation');
                        }, children: t('Lbp4pIdaQaVK') }))] }), _jsx(JsonView, { data: value || {}, shouldExpandNode: allExpanded, style: {
                    ...defaultStyles,
                    container: `_GzYRV ${cls.jsonViewContainer}`,
                    label: cls.jsonViewLabel,
                    nullValue: cls.jsonViewNullValue,
                    undefinedValue: cls.jsonViewUndefinedValue,
                    stringValue: cls.jsonViewStringValue,
                    booleanValue: cls.jsonViewbBooleanValue,
                    numberValue: cls.jsonViewbNumberValue,
                    otherValue: cls.jsonViewbOtherValue,
                    collapseIcon: `${cls.jsonViewbCollapseIcon} _f10Tu _1MFti _1LId0`,
                    punctuation: cls.jsonViewbPunctuation,
                    expandIcon: `${cls.jsonViewbExpandIcon} _f10Tu _1MFti _1UmXx`,
                    collapsedContent: `${cls.jsonViewbCollapsedContent} _1pNG9 _1MFti`,
                } })] }));
};
export const useAuditLogDetail = () => {
    const { open, close } = useDetailDrawer({
        path: '/systemLog/auditLog',
        i18nKey: 'FPso6lcNJLvc',
        creatRoot: createRoot,
        component: _jsx(Detail, {}),
    });
    return { open, close };
};
